<script setup>
const props = defineProps(['data', 'limit']);

const columns = ref(3);
const { screenWidth } = useScreenWidthListener();

watch(screenWidth, () => {
  calculateColumns(screenWidth.value);
});

const calculateColumns = (width) => {
  if (width < 768) {
    return (columns.value = 1);
  } else if (width >= 768 && width < 1400) {
    return (columns.value = 2);
  } else {
    return (columns.value = 3);
  }
};
</script>

<template>
  <div class="flex">
    <div v-for="columnIndex in columns" :key="columnIndex" class="column">
      <div v-for="(item, index) in data" :key="index">
        <div v-if="(index + 1 - columnIndex) % columns === 0">
          <div class="event-wall__holder">
            <div v-if="index < limit ? limit : 999" class="event-wall__item">
              <EventWallItem :data="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.event-wall {
  @include mq($md) {
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
  }

  &__item {
    margin-top: 40px;
    transform-origin: center top;
    width: 100%;

    &:first-child {
      margin-top: 0;
    }

    @include mq($md) {
      padding: 0 15px;
      width: 50%;

      &:nth-child(-n + 2) {
        margin-top: 0;
      }
    }

    @include mq($lg) {
      margin-top: 80px;

      &:nth-child(-n + 2) {
        margin-top: 0;
      }
    }

    @include mq($xxl) {
      &:nth-child(-n + 3) {
        margin-top: 0;
      }

      width: calc(100% / 3);
    }
  }
}

.event-wall__item {
  width: 100%;
  transition-duration: 350ms;
  padding-bottom: 2rem;
}

.flex {
  display: flex;
  width: calc(100% + 30px);
  margin: 0 -15px;
  @media (max-width: 768px) {
    display: block;
    margin: auto;
    width: 100%;
  }
}
.column {
  transition-duration: 350ms;
  //margin: 8px;
  flex: 1;
  flex-basis: 0;
  min-width: 0;
}
</style>
